<template>
    <div class="news-ct fs16 pl5">
        <router-link v-for="item in newsList" :key="item.id" :to="`${$params.baseDir}${link}/${item['id']}?typeId=${item.category_id}`" 
            class="news-s dblock lh18 mb10 prelative before dflex" :title="item.title">
            <span class="date dnone mcolor mr5 ml5">{{item.open_time | getMonth}} </span>
            <span class="t-hidden">{{item.title}}</span>
            <span class="tc9  adate fs14 pl20">{{item.open_time}}</span>
        </router-link>
    </div>
</template>
<script>
export default {
    props: ['newsList', 'link'],
    filters: {
        getMonth(date){
            if(!date)
                return ''
            return `[${date.substr(5)}]`
        }
    }
}
</script>
<style>
    .dnone{
        display: none !important    ;
    }
    .news-s{
        display: flex;
    }
    .adate,
    .date{
        /* display: none; */
        flex-shrink: 0;
    }
    .t-hidden{
       flex-grow: 1;
    }
    .news-s:hover{
        /* text-decoration: underline; */
        font-weight: bold;
    }
    .news-s:hover .adate{
        color: var(--mcolor);
    }
    .news-show-date .date{
        display: inline-block;
    }
    .cbr50 .news-s::before{
        border-radius: 50%;
        
    }
    .bashed .news-s{
        border-bottom: 1px dashed #e3e3e3;
    }
    .adate{
        flex-shrink: 0;
    }
    .padate .adate{
        display: inline-block;
    }
    .news-train .news-s{
        margin-bottom: 5px;
        padding-top: 3px;
        padding-bottom: 6px;
        bottom: 0;
    }
    .train-news .t-hidden{
        padding-right: 0;
        line-height: 2;
        font-size: 14px;
    }
</style>